<div class="preview-frame-holder" (click)="close(true)">

  <div *ngIf="isLoading" class="iframe-loading-spinner">
    <app-loading-dots size="5px"></app-loading-dots>
  </div> 
  <div class="preview-frame-holder--row-controls-container">

    <p-button severity="info" variant="text" (click)="downloadFile($event)">
      <i class="fa-light fa-file-arrow-down"></i>
    </p-button>

    <div class="close-icon" (click)="close(false)"><i class="fas fa-times"></i></div>
  </div>

  <iframe (load)="loadIframe($event)" *ngIf="pdf" [src]="getURL() | safe"></iframe>


  <div class="image-preview-holder" *ngIf="image">
    <img [src]="data.url | safe" />
    <p class="preview-frame-text">{{ data?.title }}</p>
  </div>